// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35Nmv","content":"styles_content__tMV2B","tableWrap":"styles_tableWrap__4gye_"};